module.exports = __webpack_public_path__ + "static/bg-sec11-6c2c7f87759474d8e49dfc50b7c45975.jpg";